import React, { useEffect, useState } from "react";
import Layout from "../component/Layout/Layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getPriceForOrder, dateInMDY, formatUIText } from "../Helper";
import axios from "axios";
import { useAuth } from "../context/auth";
import { useMutation } from "@tanstack/react-query";
import { CreateRatingAPI } from "../component/APIS";
import { Form, Modal, Button } from "react-bootstrap";
export default function OrdersDetail() {
  const [auth] = useAuth();
  const [userId] = useState(auth?.user.id);
  const [orderData, setOrderData] = useState({});
  const [orderscurrency, setOrdersCurrency] = useState("");
  const [ordersExchangeRate, setordersExchangeRate] = useState("");
  const [orderDetails, setOrderDetails] = useState([]);
  const [shipping, setShipping] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [loading, setLoading] = useState(false);
  const { order_no } = useParams();
  const [savedMgmt, setSavedMgmt] = useState("");

  /*   console.log(params) */
  const getOrderData = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/customer/order/list?customer_id=${userId}`
      );
      const od = data?.filter((item) => item.id == order_no);
      if (od) {
        setOrderData(od[0]);
        setShipping(od[0]?.shipping_address_data);
        setCouponDiscount(od[0]?.discount_amount);
        setOrdersCurrency(od[0]?.currency);
        setordersExchangeRate(od[0]?.exchange_rate);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const [totalMrp, setTotalMrp] = useState(0);
  const [totalAmount, setTotalAmount] = useState("");
  const [productDiscount, setProductDiscount] = useState(0);
  const [productTax, setProductTax] = useState(0);
  const [productShipping, setProductShipping] = useState(0);
  const [orderAmount, setorderAmount] = useState(0);
  const [onlinePaymentDiscount, setonlinePaymentDiscount] = useState(0);
  const [welcomeDiscount, setWelcomeDiscount] = useState(0);
  const [cod, setCOD] = useState(0);
  const [codBalance, setCODBalance] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentRef, setPaymentRef] = useState('');
  const [customItmId, setCustomItmId] = useState({});
  const getOrderDataDetails = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/customer/order/details?order_id=${order_no}`
      );
      /* console.log(data) */

      let total_mrp = 0;
      let total_discount = 0;
      let total_shipping = 0;
      let total_tax = 0;
      let total_onlinePaymentDiscount = 0;
      let total_welcomeDiscount = 0;
      data.forEach((item, i) => {
        total_mrp = total_mrp + item.price * item.qty;
        total_discount = total_discount + item.discount * item.qty;
        total_shipping= item?.orders?.shipping_cost;
        
        total_tax = total_tax + item.tax * item.qty;

        /// for measurement id
        let mgt_data = JSON.parse(item.measurement_data);
        if (mgt_data?.measurement_id) {
          setCustomItmId({
            [item.id]: {
              measurement_id: mgt_data.measurement_id,
              dt: mgt_data.created_at,
            },
          });
        }
      });
      total_onlinePaymentDiscount = data[0]?.orders?.extra_discount;
      total_welcomeDiscount = data[0]?.orders?.welcome_discount;
      setTotalMrp(total_mrp);
      setProductDiscount(total_discount);
      setProductTax(total_tax);
      setProductShipping(total_shipping);
      setonlinePaymentDiscount(total_onlinePaymentDiscount);
      setWelcomeDiscount(total_welcomeDiscount);
      if(data[0]?.orders?.cod===1){
        setCOD(data[0]?.orders?.cod);
        setCODBalance(data[0]?.orders?.cod_balance); 
      }
      setorderAmount(data[0]?.orders?.order_amount);
      setPaymentMethod(data[0]?.orders?.payment_method);
      setPaymentRef(data[0]?.orders?.transaction_ref);
      setTotalAmount((total_mrp + total_tax + total_shipping - total_discount - total_welcomeDiscount)- total_onlinePaymentDiscount);
      /* setTotalAmount(total_mrp+total_tax+total_shipping-(total_discount)) */
      setOrderDetails(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrderData();
    getOrderDataDetails();
    getMeasurement();
  }, []);

  const updateMeasurementById = async (o_id, measurement_id) => {
    try {
      setLoading(true);
      if (measurement_id === "new") {
        window.open("/measurements", "_blank");
        setLoading(false);
        return;
      }
      let { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/customer/measurement/update_order_measurement`,
        { o_id, measurement_id }
      );
      //console.log('==>>',data)
      if (data?.status) {
        setSavedMgmt(data?.result);
        getOrderData();
        getOrderDataDetails();
        getMeasurement();
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getMeasurement = async () => {
    try {
      let { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/customer/measurement/get_measurement?customer_id=${userId}`
      );
      //console.log(data)
      if (data?.status) {
        setSavedMgmt(data?.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [productId, setProductId] = useState("");
  const [validated, setValidated] = useState(false);
  const [updateMsg, setUpdateMsg] = useState("");
  const [popUpProductName, setPopUpProductName] = useState("");
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const shortid = require("shortid");
  const [selectedfile, SetSelectedFile] = useState([]);
  const [FilesUpdate, SetFilesUpdate] = useState([]);

  const [currentRating, setRatingAdd] = useState({
    customer_id: userId,
    rating: "",
    comment: "",
    product_id: "",
  });

  const changeHandle = async (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setRatingAdd({
      ...currentRating,
      [name]: value,
    });
  };

  const handleAddReview = (product_id, product_name) => {
    setProductId(product_id);
    setRatingAdd({
      ...currentRating,
      product_id: product_id,
    });
    setShow(true);
    setPopUpProductName(product_name);
  };

  const addMutation = useMutation({
    mutationFn: CreateRatingAPI,
    onSuccess: (data) => {
      setUpdateMsg(data.message);
      setRatingAdd({
        rating: "",
        comment: "",
        product_id: "",
      });
      SetSelectedFile([]);
      setValidated(false);
      setButtonDisabled(false);
      setTimeout(() => {
        handleClose();
        setUpdateMsg("");
      }, 1000);
    },
  });

  const handleCreateRating = async (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    setValidated(true);
    if (form.checkValidity() === true) {
      setButtonDisabled(true);
      if (selectedfile.length > 0) {
        let tempImages = [];
        for (let index = 0; index < selectedfile.length; index++) {
          //console.log(selectedfile[index])
          tempImages.push(selectedfile[index])
        }
        setRatingAdd();
        addMutation.mutate({
          ...currentRating,
          images: [...FilesUpdate, ...tempImages],
        });
      } else {
        addMutation.mutate(currentRating);
      }
    }
  };

  const filesizes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const InputChange = (e) => {
    // --For Multiple File Input
    let images = [];
    for (let i = 0; i < e.target.files.length; i++) {
      images.push(e.target.files[i]);
      let reader = new FileReader();
      let file = e.target.files[i];
      let imageType = /image.*/;
      if (!file.type.match(imageType)) {
        continue;
      }
      reader.onloadend = () => {
        SetSelectedFile((preValue) => {
          return [
            ...preValue,
            {
              id: shortid.generate(),
              filename: e.target.files[i].name,
              filetype: e.target.files[i].type,
              fileimage: reader.result,
              //datetime:e.target.files[i].lastModifiedDate.toLocaleString("en-IN"),
              filesize: filesizes(e.target.files[i].size),
            },
          ];
        });
      };
      if (e.target.files[i]) {
        reader.readAsDataURL(file);
      }
    }
  };

  const DeleteSelectFile = (id) => {
    if (window.confirm("Are you sure you want to delete this Image?")) {
      const result = selectedfile.filter((data) => data.id !== id);
      SetSelectedFile(result);
    } else {
      // alert('No');
    }
  };

  return (
    <Layout
      title="My Orders : Chaashni by Maansi & Ketan"
      description="Chaashni by Maansi & Ketan: Description">
      <div className={`site-content-wrap my-account ${loading ? "loading" : ""}`}>

        <div className="container">
          {!loading ? (
            <div className="row">
              <div className="col-md-12">
                <h1 className="sustom-heading-h1">
                  Orders <span>Detail</span>
                </h1>
                <div className="content-box">
                  <p className="custom-centet extra-class">
                    Order <span className="order-number-1"><b>#{order_no}</b> </span> 
                    was placed on {" "}
                    <span className="order-date-1">
                      {orderData?.created_at !== ""
                        ? dateInMDY(orderData?.created_at)
                        : ""}
                    </span> 
                    {" "}and is currently 
                    <span className="order-status-1">
                      {" "}{orderData?.order_status}.
                    </span>
                  </p>
                  <div className="custom-two-box">
                    <section className="order-details">
                      <h2 className="order-details__title">Order details</h2>
                      <table className="table--order-details custom-table orders-detail-table">
                        <tbody>
                          <tr>
                            <th>Order number</th>
                            <td className="text-right">{orderData?.id}</td>
                          </tr>
                          <tr>
                            <th>Date</th>
                            <td className="text-right">
                              {orderData?.created_at !== ""
                                ? dateInMDY(orderData?.created_at)
                                : ""}
                            </td>
                          </tr>

                          {orderDetails?.map((product, index) => (
                            <tr key={index}>
                              <td>
                                <div className="product-summary">
                                  <Link to={`/product/${product.product_details.slug}`} target="_blank">
                                    <img
                                      className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                      width={50}
                                      src={`${process.env.REACT_APP_IMAGE_URL}/product/thumbnail/${product.product_details.thumbnail}`}
                                      alt={product.product_details.name}
                                      title={product.product_details.name}
                                    /> 
                                  </Link>
                                  <div className="product-summary-right">
                                    <Link
                                      to={`/product/${product.product_details.slug}`}
                                      target="_blank"
                                    >
                                      {product.product_details.name}
                                    </Link>
                                    <strong className="product-quantity">
                                       
                                      × {product.qty}
                                    </strong>
                                    <div className="product-sizebox">
                                      {Object.entries(product?.variation).map(
                                        ([keydata, valuedata], i) => (
                                          <div
                                            className="product-variation"
                                            key={i}
                                          >
                                            <span>
                                              <strong>{keydata}:</strong>
                                              {valuedata === "CUSTOMTAILORED"
                                                ? valuedata.replace(
                                                    "CUSTOM",
                                                    "CUSTOM "
                                                  )
                                                : valuedata}
                                            </span>

                                            {valuedata === "CUSTOMTAILORED" ? (
                                              <div className="product-variation-measurement">
                                                {/* JSON.stringify(customItmId) */}
                                                {Object.keys(customItmId)
                                                  .length !== 0 && (
                                                  <>
                                                    <strong>
                                                      Select Measurement:
                                                    </strong>
                                                    <select
                                                      value={
                                                        customItmId[product.id]
                                                          .measurement_id
                                                      }
                                                      onChange={(e) => {
                                                        updateMeasurementById(
                                                          product.id,
                                                          e.target.value
                                                        );
                                                      }}
                                                    >
                                                      <option value="">
                                                        --Select--
                                                      </option>
                                                      {savedMgmt?.map(
                                                        (item, i) => (
                                                          <option
                                                            key={i}
                                                            value={item.id}
                                                          >
                                                            {item.name}
                                                          </option>
                                                        )
                                                      )}
                                                      <option value="new">
                                                        + Add New Measurement
                                                      </option>
                                                    </select>
                                                    <div>
                                                      <strong>
                                                        Updated On:
                                                      </strong> 
                                                      {dateInMDY(
                                                        customItmId[product.id]
                                                          .dt
                                                      )}
                                                    </div>
                                                  </>
                                                )}
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        )
                                      )}
                                      <div className="product-variation"><span><strong>Type:</strong>{product?.order_type}</span></div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td>
                                {orderscurrency} 
                                {getPriceForOrder(
                                  product.price * product.qty,
                                  ordersExchangeRate
                                )}
                                {product.delivery_status === "delivered" && (
                                  <>
                                    <br />
                                    <Link
                                      title="Submit Review"
                                      onClick={() => {
                                        handleAddReview(
                                          product.id,
                                          product.product_details.name
                                        );
                                      }}
                                    >
                                      <i className="fa-solid fa-comments"></i>
                                    </Link>
                                  </>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th>Item:</th>
                            <td>{orderDetails?.length}</td>
                          </tr>
                          <tr>
                            <th>Subtotal:</th>
                            <td>
                              {orderscurrency} 
                              {getPriceForOrder(totalMrp, ordersExchangeRate)}
                            </td>
                          </tr>

                          {productTax > 0 ? (
                            <tr>
                              <th>Text fee:</th>
                              <td>
                                {orderscurrency} 
                                {getPriceForOrder(
                                  productTax,
                                  ordersExchangeRate
                                )}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}

                          <tr>
                            <th>Shipping:</th>
                            <td>
                              {orderscurrency} 
                              {getPriceForOrder(
                                productShipping,
                                ordersExchangeRate
                              )}
                            </td>
                          </tr>
                          {productDiscount > 0 ? (
                            <tr className="red-text">
                              <th>Discount On product:</th>
                              <td>
                                - {orderscurrency} 
                                {getPriceForOrder(
                                  productDiscount,
                                  ordersExchangeRate
                                )}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {couponDiscount > 0 ? (
                            <tr className="red-text">
                              <th>Coupon Discount:</th>
                              <td>
                                - {orderscurrency} 
                                {getPriceForOrder(
                                  couponDiscount,
                                  ordersExchangeRate
                                )}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                          {onlinePaymentDiscount > 0 && (
                          <tr className="red-text">
                            <th>100% Prepayment Discount:</th>
                            <td> <span className="minus-sign">-</span>  
                              {orderscurrency} 
                              {getPriceForOrder(
                                onlinePaymentDiscount,
                                ordersExchangeRate
                              )}
                            </td>
                          </tr>
                          )}
                          {welcomeDiscount > 0 && (
                          <tr className="red-text">
                            <th>Tik Tok Discount:</th>
                            <td> <span className="minus-sign">-</span>  
                              {orderscurrency} 
                              {getPriceForOrder(
                                welcomeDiscount,
                                ordersExchangeRate
                              )}
                            </td>
                          </tr>
                          )}
                          <tr className="total-wrap">
                            <th>Total:</th>
                            <td>
                              {orderscurrency} 
                              {getPriceForOrder(
                                totalAmount ,
                                ordersExchangeRate
                              )}
                            </td>
                          </tr>
                          {cod === 1 && (
                          <tr>
                            <th>Online Payment (Paid):</th>
                            <td><span className="minus-sign">-</span>
                            {orderscurrency} 
                              {getPriceForOrder(
                                totalAmount - couponDiscount - codBalance,
                                ordersExchangeRate
                              )}
                            </td>
                          </tr>
                          )}
                          {cod === 1 && codBalance > 0 && (
                          <tr>
                            <th><b>Cash on Delivery (Due):</b></th>
                            <td><b>   
                            {orderscurrency} 
                              {getPriceForOrder(
                                codBalance,
                                ordersExchangeRate
                              )}</b>
                            </td>
                          </tr>
                          )} 
                        </tfoot>
                      </table>
                    </section>
                    <section className="customer-details">
                      <h2 className="column__title">Shipping Address</h2>
                      <address>
                        <div className="name">{shipping?.contact_person_name}</div>                        
                        {shipping?.address}, {shipping?.city}
                        <br />
                        {shipping?.landmark !== undefined &&  shipping?.landmark !== null? (
                          <>
                            Landmark: {shipping?.landmark}
                            <br />
                          </>
                        ) : (
                          ""
                        )}
                        {shipping?.state}
                        <br />
                        {shipping?.country} - {shipping?.zip}
                        <p className="customer-details--phone">
                          <span>Phone number:</span> {shipping?.phone}<br/>
                        <span>Email id:</span> {auth?.user.email}
                        </p>
                      </address>
                      <div className="payment_details">
                      <h2 className="column__title">Payment Method</h2>
                      <p><span>Payment Method</span> : {formatUIText(paymentMethod)}<br />
                      <span>Payment Reference</span> : {paymentRef}</p>
                      <div className="payment-img">
                        <img
                            src="/images/secure-payment.png"
                            width={433}
                            height={65}
                            alt="secure-payment"
                          />
                      </div>
                      </div>
                    </section>
                    
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Form
          noValidate
          className="edit-address-form add-review"
          validated={validated}
          onSubmit={handleCreateRating} encType="multipart/form-data"
        >
          <Form.Control type="hidden" name="product_id" value={productId} />
          <Modal.Header closeButton>
            <Modal.Title>Submit a review for <strong>{popUpProductName}</strong></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {updateMsg !== "" ? (
              <p className="text-success text-center">{updateMsg}</p>
            ) : (
              ""
            )}
            <Form.Group className="mb-3" controlId="exampleForm.rating">
              <Form.Label>Rating</Form.Label>
              <Form.Select
                aria-label="select Rating"
                name="rating"
                value={currentRating?.rating}
                defaultValue={currentRating?.rating}
                onChange={changeHandle}
                required
              >
                <option value="">-- Select rating --</option>
                <option value="5">5 Excellent </option>
                <option value="4">4 Good</option>
                <option value="3">3 Average</option>
                <option value="2">2 Below Average </option>
                <option value="1">1 Poor</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.comment">
              <Form.Label>Comment</Form.Label>
              <Form.Control
                as="textarea"
                name="comment"
                value={currentRating?.comment}
                onChange={changeHandle}
                required
                rows={3}
              />
            </Form.Group>
            {/*  <Form.Group className="mb-3" controlId="exampleForm.attachment">
              <Form.Label>Attachment</Form.Label>
              <Form.Control type="file" accept="image/jpg, image/jpeg, image/png" />
            </Form.Group> */}
            <div className="fileupload-view mt-4">
              
                 
                      <div className="kb-data-box">
                        <div className="kb-modal-data-title">
                          <div className="kb-data-title">
                          <label className="form-label" for="exampleForm.comment">Multiple File Upload With Preview</label>
                          </div>
                        </div>

                        <div className="kb-file-upload">
                          <div className="file-upload-box">
                            <input
                              type="file"
                              id="fileupload"
                              className="file-upload-input"
                              onChange={InputChange}
                              multiple
                              accept="image/jpg, image/jpeg, image/png"
                            />
                            <span>
                              Drag and drop or  
                              {' '}<span className="file-link">
                                Choose your files
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="kb-attach-box mb-3">
                          {selectedfile.map((data, index) => {
                            const {
                              id,
                              filename,
                              filetype,
                              fileimage,
                              datetime,
                              filesize,
                            } = data;
                            return (
                              <div className="file-atc-box" key={id}>
                                {filename.match(/.(jpg|jpeg|png)$/i) ? (
                                  <div className="file-image">
                                     
                                    <img src={fileimage} alt="" />
                                  </div>
                                ) : (
                                  <div className="file-image">
                                    <i className="far fa-file-alt"></i>
                                  </div>
                                )}
                                <div className="file-detail">
                                  {/* <h6>{filename}</h6>
                                  <p></p>
                                  <p>
                                    <span>Size : {filesize}</span>
                                    <span className="ml-2">
                                      Modified Time : {datetime}
                                    </span>
                                  </p> */}
                                  <div className="file-actions">
                                      <i className="fa-regular fa-trash-can" onClick={() => DeleteSelectFile(id)}></i>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                  
              
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit" disabled={isButtonDisabled}>
              Submit Review
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Layout>
  );
}
